// Ops-board own-booking conflict interrupt (reinstated S48 follow-up). A proactive bottom-right
// alert for a conflict-class notice on one of the CURRENT user's OWN bookings — an extra salience
// layer beyond the global header bell. Sourced from the SHARED notifications (useNotifications via
// context) filtered to ownTaskIds — NOT a second fetch. Suppressed while any form/modal is open so
// it never interrupts an in-progress save (v2 §10.1 / scope decision 3); single-tap dismiss.

import { C, F } from './theme';
import type { AppNotification } from '../../lib/conflicts';

interface Props {
  notifications: AppNotification[];
  ownTaskIds: Set<string>;
  suppress: boolean; // true while any form/modal is open
  onOpenConflict: (conflictId: string) => void;
  onRead: (id: string) => void;
  onDismiss: (id: string) => void;
}

export default function OwnConflictPopup({ notifications, ownTaskIds, suppress, onOpenConflict, onRead, onDismiss }: Props) {
  // Newest unread + undismissed CONFLICT notice on one of the user's own bookings.
  const popup = suppress ? null : notifications.find(
    (n) => !n.dismissed_at && !n.read_at && !!n.conflict_item_id && !!n.task_id && ownTaskIds.has(n.task_id),
  );
  if (!popup) return null;

  const review = () => {
    if (popup.conflict_item_id) onOpenConflict(popup.conflict_item_id);
    onRead(popup.id);
  };

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, width: 320, background: C.surface, border: `1px solid ${C.redBorder}`, borderRadius: 10, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', zIndex: 450, fontFamily: F, overflow: 'hidden' }}>
      <div style={{ background: '#fef2f2', padding: '10px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: C.red }}>⚠ {popup.title}</div>
        <button onClick={() => onDismiss(popup.id)} title="Dismiss" style={{ background: 'none', border: 'none', color: C.textMuted, cursor: 'pointer', fontSize: 15 }}>✕</button>
      </div>
      <div style={{ padding: '10px 12px' }}>
        <div style={{ fontSize: 11, color: C.textDim, lineHeight: 1.5, marginBottom: 8 }}>{popup.message}</div>
        <button onClick={() => { review(); onDismiss(popup.id); }}
          style={{ background: C.navy, border: 'none', color: '#fff', borderRadius: 6, padding: '7px 12px', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: F }}>
          Review &amp; resolve
        </button>
      </div>
    </div>
  );
}
